import React from 'react';
import PropTypes from 'prop-types';
import amp from 'lib/amp';

export default function AmpRender(WrappedComponent) {
  const AmpComponent = ({
    pid,
  }) => (
    <div>
      <amp-iframe
        frameborder="0"
        width="480"
        height="270"
        layout="responsive"
        sandbox="allow-scripts allow-same-origin"
        src={`https://www.nbcnews.com/playmaker/embed/${pid}`}
      >
        <amp-img
          height="253"
          src="https://media4.s-nbcnews.com/j/newscms/2019_01/2705191/nbc-social-default_b6fa4fef0d31ca7e8bc7ff6d117ca9f4.focal-480x253.png"
          layout="fill"
          placeholder
          width="480"
        />
      </amp-iframe>
    </div>
  );

  AmpComponent.propTypes = {
    pid: PropTypes.number.isRequired,
  };

  return amp(AmpComponent)(WrappedComponent);
}
